var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 98,
    viewBox: "0 0 57 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28.08C24.37 30.81 31.56 38.35 33.84 47.84L35.84 56.16L37.84 47.84C40.12 38.35 47.31 30.81 56.68 28.08C47.3 25.35 40.11 17.81 37.83 8.33L35.83 0L33.83 8.33C31.56 17.81 24.37 25.35 15 28.08Z",
    fill: "#F2BC00"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_209_640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 76.9963C6.97072 79.0376 12.3197 84.6755 14.0158 91.7714L15.5037 97.9925L16.9916 91.7714C18.6878 84.6755 24.0367 79.0376 31.0074 76.9963C24.0293 74.955 18.6803 69.3171 16.9842 62.2286L15.4963 56L14.0084 62.2286C12.3197 69.3171 6.97072 74.955 0 76.9963Z",
    fill: "#F2BC00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.67,
    height: 56.17,
    fill: "white",
    transform: "translate(15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_209_640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    fill: "white",
    transform: "translate(0 56)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.f6c26cf64abdd3f6d04f106e90df1850.svg";
export { ForwardRef as ReactComponent };